@if (errors.length) {
  <nb-alert outline="danger">
    @for (err of errors; track err) {
      <p>{{ err }}</p>
    }
  </nb-alert>
}

@if (!model.uuid && allowProjectUpdate) {
  <p>
    <button nbButton type="button" status="primary" (click)="startOffice()">
      Start Office Time Tracking
    </button>
  </p>
}

<form [formGroup]="form" (ngSubmit)="submit()">
  <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>

  <!--  @if (model.denormalized?.surveyTask?.tasks) {-->
  <!--    <dl>-->
  <!--      <dt>Survey Tasks</dt>-->
  <!--      <dd>-->
  <!--        @for (task of model.denormalized?.surveyTask?.tasks; track task) {-->
  <!--          <li>-->
  <!--            {{ $any(task) | formatSurveyTaskGeneric: model?.task?.custom?.text }}-->
  <!--          </li>-->
  <!--        }-->
  <!--      </dd>-->
  <!--    </dl>-->
  <!--    <ul class="table-list"></ul>-->
  <!--  }-->

  <vmspdb-ui-debug [model]="model"></vmspdb-ui-debug>
  <vmspdb-ui-debug [model]="formErrors" name="Errors"></vmspdb-ui-debug>
  <p>
    <button
      type="submit"
      nbButton
      status="primary"
      class="me-1"
      [nbSpinner]="processing"
      [disabled]="
        (invalid && allowProjectUpdate) ||
        model.crewLeader === undefined ||
        processing
      "
      [innerText]="switchingProjects ? 'Switch' : 'Start'"
    ></button>

    @if (switchingProjects) {
      <button
        type="button"
        nbButton
        status="primary"
        class="float-end"
        (click)="clockOut()"
      >
        Clock Out
      </button>
    }
  </p>
</form>
